module.exports = __webpack_public_path__ + "static/media/icon-medal.36de06a6.svg";